<template>
  <section>
    <div
      v-if="isShowTextCount"
      class="pega-count-moji-area inner"
    >
      <preview-text-count
        v-if="caption.max"
        :name="getColumnName + '見出し'"
        :count-target="caption"
      />
      <preview-text-count
        v-if="text.max"
        :name="caption.value ? getColumnName + '本文' : getColumnName"
        :count-target="text"
        :class="{'mt10':caption.value}"
        data-test="text-count-max"
      />
    </div>
    <preview-job-comments
      :comments="commentHighlights"
      :is-show="isShowComment"
      class="pega-comment-bar-inner"
      v-on="$listeners"
    />
    <h5 v-if="title">
      <span data-test="title">{{ title }}</span>
    </h5>
    <h5
      v-if="caption.value"
      :id="id + '-caption'"
      class="margin-left-0"
      data-test="caption"
    >
      {{ caption.value }}
    </h5>
    <span
      v-if="isEngineer"
      class="jobonlyicon"
      data-test="is-engineer"
    >エンジニア限定取材</span>
    <span
      v-if="isSales"
      class="jobonlyicon"
      data-test="is-sales"
    >営業職限定取材</span>
    <span
      v-if="isWorkstyle"
      class="size-small"
      data-test="is-workstyle"
    >（<a
      target="_blank"
      style="cursor: pointer;"
      :href="workstyleHelpMarkURL"
    >項目の説明</a>）
    </span>
    <component
      :is="tag"
      v-if="text.value"
      :id="id"
      class="pega-pre-wrap"
      :class="{'workstyle-bold':isWorkstyle, 'remarks-margin-bottom': hasRemarks}"
      data-test="text"
      v-text="text.value"
    />
    <template v-if="suitablePerson">
      <p class="orient">
        向いている人
      </p>
      <div
        v-if="isShowTextCount"
        class="pega-count-moji-area inner"
      >
        <preview-text-count
          name="向いている人"
          :count-target="suitablePerson.suitableForThisJob"
        />
      </div>
      <p
        :id="id + '-suitable'"
        class="pega-pre-wrap"
        data-test="suitable"
        v-text="suitablePerson.suitableForThisJob.value"
      />
      <p class="orient">
        向いていない人
      </p>
      <div
        v-if="isShowTextCount"
        class="pega-count-moji-area inner"
      >
        <preview-text-count
          name="向いていない人"
          :count-target="suitablePerson.notSuitableForThisJob"
        />
      </div>
      <p
        :id="id + '-not-suitable'"
        class="pega-pre-wrap"
        data-test="not-suitable"
        v-text="suitablePerson.notSuitableForThisJob.value"
      />
    </template>
  </section>
</template>

<style scoped lang="scss">
@use "@/styles/preview/pc/base" as *;
</style>

<script>
import PreviewJobComments from '@/components/molecules/PreviewJobComments'
import PreviewTextCount from '@/components/atoms/PreviewTextCount'
import jobPreviewCommon from '@/lib/jobPreviewCommon'
export default {
  components: {
    PreviewJobComments,
    PreviewTextCount
  },
  mixins: [jobPreviewCommon],
  props: {
    id: {
      type: String,
      required: true
    },
    tag: {
      type: String,
      required: true
    },
    text: {
      type: Object,
      default: () => { return { value: '', max: 0 } }
    },
    title: {
      type: String,
      default: ''
    },
    suitablePerson: {
      type: Object,
      default: () => {}
    },
    isEngineer: {
      type: Boolean,
      default: false
    },
    isSales: {
      type: Boolean,
      default: false
    },
    isWorkstyle: {
      type: Boolean,
      default: false
    },
    hasRemarks: {
      type: Boolean,
      default: false
    },
    caption: {
      type: Object,
      default: () => { return { value: '', max: 0 } }
    },
    columnName: {
      type: String,
      default: ''
    },
    commentHighlights: {
      type: Array,
      default: () => []
    },
    isShowComment: {
      type: Boolean,
      required: true
    },
    isShowTextCount: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    getColumnName () {
      return this.columnName || this.title || this.id
    }
  },
  mounted () {
    this.commentHighlights.forEach((commentHighlight) => {
      this.setHighlight(commentHighlight)
    })
  }
}
</script>
